<template>
  <div v-loading="loading" style="margin-top: 10px">
    <div class="notice-header" style="text-align: center;padding: 18px 0">
        <h2 class="title-A">{{ project.projectname }}</h2>
        <div class="line-A" style="color: #000;font-size: 18px;">项目信息</div>
        <div class="line-A"></div>
    </div>
    <div>
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目编号</div>
              <div class="view-value">{{ project.projectcode }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">平台编号</div>
              <div class="view-value">{{ project.projectno }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">所在地区</div>
              <div class="view-value">{{ projectAreaNmae }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">采购人</div>
              <div class="view-value">{{ project.pcomfullname }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">联系人</div>
              <div class="view-value">{{ project.pusername }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">联系方式</div>
              <div class="view-value">{{ project.projectptel }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目名称</div>
              <div class="view-content" style="width: 611px">
                {{ project.projectname }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">品目类型</div>
              <div class="view-value">{{ project.pmname }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">交易方式</div>
              <div class="view-value">{{ project.prsflgdesc }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">评审方法</div>
              <div class="view-value">{{ project.projectdoneflgdesc }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">价格分依据</div>
              <div class="view-value">
                {{ project.projectpricecomputebasisdesc }}
              </div>
            </div>
            <div class="view-field" v-if="project.projectaveragepriceshift">
              <div class="view-label">平均价浮动率</div>
              <div class="view-value">
                {{ project.projectaveragepriceshift }}
              </div>
            </div>
          </div>
          <div class="view-row" v-if="isScoreEdit">
              <div class="view-field">
                <div class="view-label">履约分值</div>
                <div class="view-value">
                  {{ project.projectperformancescore }}
                </div>
              </div>
            </div>
          <div class="view-row">
            <div class="view-field" v-if="project.showprojectysflg">
              <div class="view-label">{{ limitamtNmae }}</div>
              <div class="view-value">
                <span v-if="project.projectlimitamt">
                  ￥{{ project.projectlimitamt | qfwVal }}元 （
                  <amount :money="String(project.projectlimitamt)" />）
                </span>
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">预算公开</div>
              <div class="view-value">
                {{ project.projectysflg ? "公开" : "不公开" }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">报价方式</div>
              <div class="view-value">
                {{ project.projecthsflg ? "含税" : "不含税" }}/{{
                  projectQuotationmodeflg
                }}
              </div>
            </div>
          </div>
          <div class="view-row" v-if="+project.projecttype === 1">
            <div class="view-field">
              <div class="view-label">代理机构</div>
              <div class="view-value">{{ project.acomfullname }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">联系人</div>
              <div class="view-value">{{ project.ausername }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">联系方式</div>
              <div class="view-value">{{ project.projectatel }}</div>
            </div>
          </div>
          <div class="view-row" v-if="
            +this.$store.getters.loginUser.comtype === 1 ||
            +this.$store.getters.loginUser.comtype === 2
          ">
            <div class="view-field">
              <div class="view-label">采购协议</div>
              <div class="view-value" style="width: 611px">
                {{ ptcInfo.ptccode }}&nbsp;&nbsp;/&nbsp;&nbsp;{{
                  ptcInfo.ptcname
                }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">业务员</div>
              <div class="view-value">
                {{ ptcInfo.cjdptname }}&nbsp;&nbsp;/&nbsp;&nbsp;{{
                  ptcInfo.ptccreatename
                }}
              </div>
            </div>
          </div>
          <div class="view-row" v-if="+this.$store.getters.loginUser.comtype !== 3">
            <div class="view-field">
              <div class="view-label">项目需求</div>
              <div>
                <div v-if="project.appendList && project.appendList.length" class="view-filelist">
                  <div v-for="(item, index) in project.appendList" :key="index" class="view-fileitem">
                    <div class="view-filename" @click="downFile(item.appendurl)">
                      <a :src="uploadAddr + item.appendurl">{{
                        item.appendfilename
                      }}</a>
                    </div>
                  </div>
                </div>
                <div v-if="currentDemandrec.demandid" @click="goLink">
                  <span class="name">{{currentDemandrec.demandname}}</span><span style="color: red;">(点击查看需求详情)</span>
                </div>
              </div>
              
            </div>
            
          </div>
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">报名方式</div>
              <div class="view-value">
                {{ +project.projectisinvite === 1 ? "邀请" : "公开" }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">报名审核</div>
              <div class="view-value">
                {{ +project.prsbmneedconfirm === 1 ? "需要" : "不需要" }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">报名数下限</div>
              <div class="view-value" v-if="project.prssupplynums > 0">
                {{ project.prssupplynums }}
              </div>
              <div class="view-value" v-else>不受限</div>
            </div>
            <!-- <div class="view-field">
              <div class="view-label">项目初审</div>
              <div class="view-value">{{+project.projectisqcheck === 1 ? '需要' : '不需要'}}</div>
            </div> -->
          </div>
          <!-- <div class="view-row">
            <div class="view-field">
              <div class="view-label">采购报告</div>
              <div class="view-value">{{+project.projectjjreportflg === 1 ? '需要' : '不需要'}}</div>
            </div>
          </div> -->
          <!-- <div class="view-row">
            <div class="view-field">
              <div class="view-label">报名下限</div>
              <div class="view-value" v-if="project.prssupplynums > 0">{{project.prssupplynums}}</div>
              <div class="view-value" v-else>不受限</div>
            </div>
          </div> -->
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">报名费</div>
              <div class="view-value">
                <span v-if="project.projectbmamt">
                  ￥{{ project.projectbmamt | qfwVal }}元 （
                  <amount :money="String(project.projectbmamt)" />）
                </span>
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">缴费方式</div>
              <div class="view-value">
                <span>{{
                  +project.projectbmpayway === 1
                    ? "线上支付"
                    : +project.projectbmpayway === 2
                      ? "线下支付"
                      : +project.projectbmpayway === 3
                        ? "线上/线下支付"
                        : ""
                }}</span>
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">保证金</div>
              <div class="view-value">
                <span v-if="project.projectbzjamt">
                  ￥{{ project.projectbzjamt | qfwVal }}元 （
                  <amount :money="String(project.projectbzjamt)" />）
                </span>
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">缴费方式</div>
              <div class="view-value">
                <span>{{
                  +project.projectbzjpayway === 1
                    ? "线上支付"
                    : +project.projectbzjpayway === 2
                      ? "线下支付"
                      : +project.projectbzjpayway === 3
                        ? "线上/线下支付"
                        : ""
                }}</span>
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">报名开始</div>
              <div class="view-value">
                {{ project.prsbmbegtime | longDate }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">报名截止</div>
              <div class="view-value">
                {{ project.prsbmendtime | longDate }}
              </div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">{{ `${prsflgName}开始` }}</div>
              <div class="view-value">
                {{ project.prsbjbegtime | longDate }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">{{ `${prsflgName}截止` }}</div>
              <div class="view-value">
                {{ project.prsbjendtime | longDate }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label" style="width: 180px;margin-left: 14px">是否允许截止时间后报价</div>
              <div class="view-value">
                {{ project.projectdelaypricepermite === 0 ? '允许' : '不允许' }}
              </div>
            </div>
            
          </div>
          <div class="view-row" v-if="
            +project.prsflg === 1 ||
            +project.prsflg === 3 ||
            +project.prsflg === 6
          ">
            <div class="view-field">
              <div class="view-label">报价轮次</div>
              <div class="view-value">{{ project.prsbjtimes }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">轮次底价</div>
              <div class="view-value">
                {{ +project.prsisopen === 1 ? "不公开" : "公开" }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">报价数下限</div>
              <div class="view-value" v-if="project.projectbidderslowerlimit > 0">
                {{ project.projectbidderslowerlimit }}
              </div>
              <div class="view-value" v-else>不受限</div>
            </div>
            <!-- <div class="view-field">
              <div class="view-label">主持人与否</div>
              <div class="view-value">{{+project.projectneedhost?'有主持':'无主持'}}</div>
            </div> -->
          </div>
          <div class="view-row" v-if="+project.prsflg === 4 || +project.prsflg === 5">
            <div class="view-field">
              <div class="view-label">梯度金额</div>
              <div class="view-value">
                ￥{{ project.projectgradientamt | qfwVal }}元 （
                <amount :money="String(project.projectgradientamt)" />）
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">自动结束时长</div>
              <div class="view-value">{{ project.prsnmin }}分钟</div>
            </div>
            <!-- <div class="view-field">
              <div class="view-label">主持人与否</div>
              <div class="view-value">{{+project.projectneedhost?'有主持':'无主持'}}</div>
            </div> -->
          </div>
          <div class="view-row">
            <div class="view-field" v-if="
              +project.prsflg === 1 ||
              +project.prsflg === 3 ||
              +project.prsflg === 6
            ">
              <div class="view-label">{{ conName }}方案</div>
              <div class="view-value">
                {{ +project.projectjjfile === 1 ? "需要" : "不需要" }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">项目初审</div>
              <div class="view-value">
                {{ +project.projectisqcheck === 1 ? "需要" : "不需要" }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">{{ prsflgName + "报告" }}</div>
              <div class="view-value">
                {{ +project.projectjjreportflg === 1 ? "需要" : "不需要" }}
              </div>
            </div>
          </div>
          <div class="view-row" v-if="$store.getters.loginUser.comtype == '1'">
            <div class="view-field">
              <div class="view-label">收费标准</div>
              <div class="view-value">{{ project.prschangeflgdesc }}</div>
            </div>
            <div v-if="+project.prschangeflg === 1" class="view-field">
              <div class="view-label">服务类型</div>
              <div class="view-value">{{ project.chargefeetypedesc }}</div>
            </div>
            <div class="view-field" v-if="+project.prschangeflg === 2">
              <div class="view-label">服务收费</div>
              <div class="view-value">
                {{ project.prschangefee | qfwVal }}
              </div>
            </div>
            <div class="view-field">
              <div class="view-label">缴费方式</div>
              <div class="view-value">
                <span>{{
                  +project.projectfeepayway === 1
                    ? "线上支付"
                    : +project.projectfeepayway === 2
                      ? "线下支付"
                      : "线上/线下支付"
                }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="view-row" v-if="$store.getters.loginUser.comtype=='1'">
            <div class="view-field">
              <div class="view-label">缴费方式</div>
              <div class="view-value">
                <span>{{+project.projectfeepayway === 1?'线上支付':(+project.projectfeepayway === 2 ? '线下支付':'线上/线下支付')}}</span>
              </div>
            </div>
          </div> -->
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">{{ conName }}内容</div>
              <div class="view-text">
                <div v-html="project.projectdesc" style="margin-top: -12px" class="content"></div>
              </div>
            </div>
          </div>
          <!-- <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">采购要求</div>
              <div class="view-text">
                <div v-html="project.prscontents" style="margin-top:-12px"></div>
              </div>
            </div>
          </div> -->
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目备注</div>
              <div class="view-content">{{ project.prsremark }}</div>
            </div>
          </div>
          <div class="view-row" v-if="+project.prsflg === 2">
            <div class="view-field">
              <div class="view-label">投标模式</div>
              <div class="view-value">
                {{
                  +project.projecttenderbidmode === 1 ? "线上投标" : "线下投标"
                }}
              </div>
            </div>
          </div>
          <div class="view-row" v-if="+project.prsflg === 2">
            <div class="view-field">
              <div class="view-label">开标模式</div>
              <div class="view-value">
                {{
                  +project.projectopenbidmode === 1 ? "现场开标" : "远程开标"
                }}
              </div>
            </div>
          </div>
          <div class="view-row" v-if="+project.prsflg === 2">
            <div class="view-field">
              <div class="view-label">{{ `${prsflgName}地址` }}</div>
              <div class="view-content">{{ project.projectbidaddr }}</div>
            </div>
          </div>
          <div class="view-row" v-if="showFile">
            <div class="view-field">
              <div class="view-label">{{ conName }}文件</div>
              <div v-if="project.appendList_zb && project.appendList_zb.length" class="view-filelist">
                <div v-for="(item, index) in project.appendList_zb" :key="index" class="view-fileitem">
                  <div class="view-filename" @click="downFile(item.appendurl)">
                    <a :src="uploadAddr + item.appendurl">{{
                      item.appendfilename | toolongOmitted
                    }}</a>
                  </div>
                </div>
              </div>
              <div v-else class="view-value">无</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label" style="color:red">确认人</div>
              <div class="view-value" style="color:red">
                {{ project.confirmerName }} {{ project.project_purchasefile_comfirmtime | longDate }}
              </div>
            </div>
            <!-- <div class="view-field">
              <div class="view-label" style="color:red">确认时间</div>
              <div class="view-value" style="color:red">
                {{ project.project_purchasefile_comfirmtime | longDate }}
              </div>
            </div> -->
          </div>
          <div class="split-line"></div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">相关公告</div>
              <div class="view-link" v-if="project.noticeList && project.noticeList.length">
                <div class="view-link-item" v-for="(item, index) in project.noticeList" :key="item.noticeid">
                  <span>{{ index + 1 }}.</span>
                  <span @click="toNotice(item)">{{
                    item.pjnoticetitle
                      ? "[" + item.pjnoticetitle + "]"
                      : "无相关公告"
                  }}</span>
                </div>
              </div>
              <div v-else class="view-value">无相关公告</div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :close-on-click-modal="false" @close="dialogClose" :visible.sync="dialogVisible" width="80%">
        <div v-if="dialogType === 1">
          <!--结果公告-->
          <!--<project-result-notice :projectid="project.projectid"></project-result-notice>-->
        </div>
        <div v-if="dialogType === 2">
          <project-other-notice :noticeid="noticeid"></project-other-notice>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import utils from "../../assets/js/utils";
// import uploadBtn from '../common/uploadBtn'
// import config from '../../assets/config'
import common from "@/mixin/common";
import moment from "moment";
// import ProjectResultNotice from '../bbgl/ProjectResultNotice'
import ProjectOtherNotice from "../bbgl/ProjectOtherNotice";
// import _ from 'lodash'
import dayjs from "dayjs";
import amount from "../common/amount";

// const SUCCESS = 1
export default {
  name: "proViewFile",
  mixins: [common],
  components: { ProjectOtherNotice, amount },
  data() {
    return {
      router: this.$router,
      currentDemandrec: {},
      project: {
        projectcode: "",
        projectauserid: "",
        projectacomid: "",
        projectatel: "",
        projectpuserid: "",
        projectpcomid: "",
        projectptel: "",
      },
      projectAreaNmae: "",
      appendList: [],
      appendList_zb: [],
      pmList: [],
      btnLoading: false,
      dialogVisible: false,
      dialogType: 0,
      noticeid: "",
      isshow: 0,
      showFile: true,
      loading: false,
      ptcInfo: {
        appends: {},
      },
    };
  },
  async created() { },
  watch: {},
  deactivated() {
    this.$destroy();
  },
  mounted() {
    this.getModel();
  },
  async activated() {
    await this.getModel();
    this.TBJJbtn();
    this.showFilefun();
  },
  filters: {
    longDate(value) {
      return value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value);
      } else {
        return value;
      }
    },
    toolongOmitted(val) {
      if (val) {
        if (val.length > 20) {
          return val.substring(0, 10) + "..." + val.substring(val.length - 4);
        } else {
          return val;
        }
      }
      return val;
    },
  },
  computed: {
    isScoreEdit () {
        if (+this.project.prsflg === 1 || +this.project.prsflg === 3 || +this.project.prsflg === 4 || +this.project.prsflg === 5) {
          if (+this.project.projectdoneflg === 4) { 
            return true
          }
        } else if(+this.project.prsflg === 2 || +this.project.prsflg === 6){ 
          if (+this.project.projectdoneflg === 5) { 
            return true
          }
        } else {
          return false
        }
    },
    uploadAddr() {
      return this.$store.getters.uploadAddr;
    },
    prsflgName() {
      if (this.project.prsflg == "2") {
        return "开标";
      } else if (this.project.prsflg == "1" || this.project.prsflg == "3") {
        return "报价";
      } else if (this.project.prsflg == "4" || this.project.prsflg == "5") {
        return "报价";
      } else if (this.project.prsflg == "6") {
        return "报价";
      }
    },
    limitamtNmae() {
      if (
        this.project.prsflg == "2" ||
        this.project.prsflg == "1" ||
        this.project.prsflg == "6"
      ) {
        return "项目预算";
      } else if (
        this.project.prsflg == "3" ||
        this.project.prsflg == "4" ||
        this.project.prsflg == "5"
      ) {
        return "项目底价";
      }
    },
    WSJJ() {
      if (+this.project.projectstatus === 10) {
        return false;
      } else {
        return true;
      }
    },
    conName() {
      if (this.project.prsflg == "4" || this.project.prsflg == "5") {
        return "报价";
      } else if (this.project.prsflg == "6") {
        return "报价";
      } else if (this.project.prsflg == "2") {
        return "招标";
      } else {
        return "报价";
      }
    },
    projectQuotationmodeflg() {
      if (+this.project.projectquotationmode === 1) {
        return "按金额报价";
      }
      if (+this.project.projectquotationmode === 2) {
        return "按上浮率报价";
      }
      if (+this.project.projectquotationmode === 3) {
        return "按下浮率报价";
      }
      if (+this.project.projectquotationmode === 4) {
        return "按折扣率报价";
      }
    },
  },
  methods: {
    goLink () {
      this.router.push(`/jjgl/demandrecView?id=${this.currentDemandrec.demandid}`)
      this.$store.commit('SET_DAMID', this.currentDemandrec.demandid)
    },
    btnClick(code) {
      this.$emit(code);
    },
    async getModel() {
      this.loading = true;
      this.btnLoading = true;
      let res = await request({
        method: "get",
        url: "/xmgl/project/findProjectById",
        params: { projectid: this.$route.query.projectid },
      });
      this.project = res;
      this.btnLoading = false;
      if (!!this.project.projectdemandid) {
        this.currentDemandrec.demandid = this.project.demandid
        this.currentDemandrec.demandname = this.project.demandname
      }
      let pmModel = this.pmList.find(
        (v) => +v.pmid === +this.project.projectpmid
      );
      if (pmModel) {
        this.project.projectpmiddesc = pmModel.pmname;
      }
      this.project.projectysflg =
        +this.project.projectysflg === 1 ? true : false;
      this.project.projecthsflg =
        +this.project.projecthsflg === 1 ? true : false;
      this.project.projectneedhost =
        +this.project.projectneedhost === 1 ? true : false;
      this.project.prsbmneedconfirm =
        +this.project.prsbmneedconfirm === 1 ? true : false;
      this.project.showprojectysflg = true;
      if (+this.$store.getters.loginUser.comtype === 3) {
        if (this.project.projectysflg === false) {
          this.project.showprojectysflg = false;
        }
      }
      if (this.project.projectid) {
        this.projectAreaNmae = await this.getAreaName();
        await this.getPtcInfo(this.project.projectptcid); //协议
      }
      // if(+this.project.projectbmpayway === 1){
      //   this.project.projectbmpaywaydesc = '线上支付'
      // } else if(+this.project.projectbmpayway === 2){
      //   this.project.projectbmpaywaydesc = '线下支付'
      // } else  if(+this.project.projectbmpayway === 3){
      //   this.project.projectbmpaywaydesc = '线上/线下支付'
      // }
      // if (this.project.projectstatus == '60') {
      //   this.project.noticeList.push({
      //     noticetitle: '关于' + this.project.projectname + '的结果公告',
      //     noticetime: this.project.projecttime,
      //     wmenuname: '结果公告'
      //   })
      // }
      this.loading = false;
    },
    async getAreaName() {
      let res = await request({
        method: "get",
        url: "/xmgl/project/getAreaName",
        params: {
          cosid: this.$store.getters.loginUser.cosid,
          projectid: this.project.projectid,
        },
      });
      return res[0].dptareaname;
    },
    toNotice(item) {
      console.log(item);
      if (item.pjnoticetype) {
        this.noticeid = item.pjnoticeid;
        // this.dialogVisible = true
        let { href } = this.$router.resolve({
          name: "pjothernotice",
          query: { pjnoticeid: this.noticeid },
        });
        window.open(href, "_blank");
        this.dialogType = 2;
      } else {
        // this.dialogVisible = true
        let { href } = this.$router.resolve({
          name: "pjothernotice",
          query: { pjnoticeid: this.noticeid },
        });
        window.open(href, "_blank");
        this.dialogType = 1;
      }
    },
    dialogClose() {
      this.dialogVisible = false;
      this.dialogType = 0;
    },
    async getPmList() {
      let pmlist = await request({
        method: "get",
        url: "/basic/pm/getPmList",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.pmList = pmlist;
    },
    async showFilefun() {
      if (this.$route.query.psuid) {
        let psuList = await request({
          method: "get",
          url: "/xmgl/project/getpsubyid",
          params: { psuid: this.$route.query.psuid },
        });
        if (
          +psuList[0].psustatus != 3 &&
          +this.project.prsbmneedconfirm === 1
        ) {
          this.showFile = false;
        }
        if (+psuList[0].projectbmamt > 0 && +psuList[0].psubmpayflg != 1) {
          this.showFile = false;
        }
        if (+psuList[0].projectbzjamt > 0 && +psuList[0].psubzjpayflg != 1) {
          this.showFile = false;
        }
      }
    },
    async setPm() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      this.$router.push({ name: "pmmxIndex", params: { form: this.project } });
    },
    async projectAnnouncement() {
      // if (+this.project.projectstatus === 10) {
      //   this.$message.warning('该项目未发布，不能发布其他公告!')
      //   return
      // }
      this.$router.push({
        name: "pjnoticeIndex",
        params: { projectid: this.project.projectid },
      });
    },
    async pexpert() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      if (this.project.projectstatus == "10") {
        this.$message.warning("项目还未发布，不能抽取评审人！");
        return;
      }
      switch (this.project.projectstatus) {
        case 10:
          this.$message.warning("项目还未发布，不能抽取评审人！");
          return;
        case 40:
          this.$message.warning("项目评标中，不能抽取评审人！");
          return;
        case 50:
          this.$message.warning("项目定标中，不能抽取评审人！");
          return;
        case 60:
          this.$message.warning("项目归档中，不能抽取评审人！");
          return;
        case 70:
          this.$message.warning("项目已完成，不能抽取评审人！");
          return;
      }
      if (this.project.projectdoneflg === "1") {
        this.$message.warning("价格定标法，不需要抽取评审人评分");
        return;
      }
      // if(!this.project.prswexperts||!this.project.prsnexperts){
      //   this.$message.warning('请先设置评审人数!')
      //   setTimeout(() => {
      //     this.$router.push({name: 'prsForm', params: {form: this.project, type: 1}})
      //   }, 900)
      //   return
      // }
      this.$router.push({
        name: "pexpertForm",
        params: { form: this.project, type: 2 },
      });
    },
    async gopbrcenter() {
      if (this.project.prsflg === 1 || this.project.prsflg === 3) {
        this.$router.push({
          name: "pbrCenterForm",
          params: {
            projectid: this.project.projectid,
            psuid: this.$route.query.psuid,
            type: 1,
          },
        });
      } else {
        this.$router.push({
          name: "auctionHall",
          params: {
            projectid: this.project.projectid,
            psuid: this.project.psuid,
            type: 1,
          },
        });
      }
    },
    goOnlineTB() {
      this.$router.push({
        name: "onlineBidding",
        params: {
          projectid: this.project.projectid,
          psuid: this.$route.query.psuid,
          type: 1,
        },
      });
    },
    async projectNotice() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      // 不需要判断采购清单是否有（竞价和招标都可以不录）
      // let pmmxList = await request({
      //   method: 'get',
      //   url: '/xmgl/project/getPmmxList',
      //   params: {projectid: this.project.projectid}
      // })
      // if (!pmmxList.length && +this.project.prsflg === 1) {
      //   this.$message.warning('请设置采购清单!')
      //   setTimeout(() => {
      //     this.$router.push({name: 'pmmxIndex', params: {form: this.project}})
      //   }, 900)
      //   return
      // }
      if (!this.project.prsbmbegtime) {
        this.$message.warning("请完善项目信息!");
        setTimeout(() => {
          this.$router.push({
            name: "projectEdit",
            params: { projectid: this.project.projectid },
          });
        }, 900);
        return;
      }
      // if (+this.project.projectisqcheck === 1) {
      //   let pqcItemList = await request({
      //     method: 'get',
      //     url: '/xmgl/pqc/getPqcitemListByProjectId',
      //     params: {projectid: this.project.projectid}
      //   })
      //   if (!pqcItemList.length) {
      //     this.$message.warning('请设置评审规则!')
      //     setTimeout(() => {
      //       this.$router.push({name: 'projectReviewRuleIndex', params: {form: this.project, type: 1}})
      //     }, 900)
      //     return
      //   }
      // }
      if (+this.project.projectdoneflg === 3) {
        let pgList = await request({
          method: "get",
          url: "/xmgl/project/getPgList",
          params: { projectid: this.project.projectid },
        });
        if (!pgList.length) {
          this.$message.warning("请设置评审规则!");
          setTimeout(() => {
            this.$router.push({
              name: "projectReviewRuleIndex",
              params: { projectid: this.project.projectid, type: 1 },
            });
          }, 900);
          return;
        }
      }
      // let pexpertList = await request({
      //   url: '/xmgl/project/getPexpertList',
      //   method: "get",
      //   params: {projectid: this.project.projectid}
      // })
      // if (this.project.projectdoneflg !== '1' && !pexpertList.length) {
      //   if(this.project.prswexperts < 0 ||this.project.prsnexperts < 0){
      //     this.$message.warning('请先设置评审人数!')
      //     setTimeout(() => {
      //       this.$router.push({name: 'prsForm', params: {form: this.project, type: 1}})
      //     }, 900)
      //     return
      //   }
      // }
      let psuList = await request({
        method: "get",
        url: "/xmgl/project/getInvitePsuListByProjectId",
        params: { projectid: this.project.projectid },
      });

      // if (Number(this.project.projectisinvite) === 1 && psuList.length === 0) {
      //   this.$message.warning('请邀请供应商!')
      //   setTimeout(() => {
      //     this.$router.push({name: 'pInviteForm', params: {form: this.project, type: 1}})
      //   }, 900)
      //   return
      // }
      let nowdate = await request({
        method: "get",
        url: "xtgl/sysdata",
      });
      if (Number(this.project.projectstatus) == 10) {
        if (
          new Date(this.project.prsbmendtime).getTime() <=
          new Date(nowdate).getTime()
        ) {
          this.$message.warning("该项目报名已结束，请重新修改项目信息!");
          setTimeout(() => {
            this.$router.push({
              name: "projectEdit",
              params: { projectid: this.project.projectid },
            });
          }, 900);
          return;
        }
      }
      this.$router.push({
        name: "projectNotice",
        params: { projectid: this.project.projectid, type: 1 },
      });
    },
    async batchPsu() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      this.$router.push({
        name: "psuBatchForm",
        params: { form: this.project, type: 1 },
      });
    },
    async invatedCom() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      if (this.project.projectstatus == "10") {
        this.$message.warning("项目还未发布，不能邀请供应商！");
        return;
      }
      if (Number(this.project.projectisinvite) !== 1) {
        this.$message.warning("邀请类项目才能邀请供应商");
        return;
      }
      if (!this.project.prsbmbegtime) {
        this.$message.warning("请先设置项目规则，再邀请供应商!");
        setTimeout(() => {
          this.$router.push({
            name: "prsForm",
            params: { form: this.project, type: 1 },
          });
        }, 900);
        return;
      }
      this.$router.push({
        name: "pInviteForm",
        params: { form: this.project, type: 1 },
      });
    },
    async setPg() {
      if (!this.project.projectid) {
        this.$message.warning("请选择一个项目!");
        return;
      }
      this.$router.push({
        name: "projectReviewRuleIndex",
        params: { projectid: this.project.projectid, type: 1 },
      });
    },
    close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "projectIndex",
      });
    },
    async TBJJbtn() {
      //供应商进去操作列表
      if (+this.$store.getters.loginUser.cositemcomtype === 3) {
        let nowdate = await request({
          method: "get",
          url: "xtgl/sysdata",
        });
        if (
          new Date(this.project.prsbmendtime).getTime() <=
          new Date(nowdate).getTime() &&
          new Date(this.project.prsbjendtime).getTime() >
          new Date(nowdate).getTime()
        ) {
          if (+this.project.prsflg === 1) {
            this.isshow = 1;
          } else if (+this.project.prsflg === 2) {
            this.isshow = 2;
          }
        }
      }
    },
    async toBMxx() {
      this.$router.push({
        name: "BMXXlist",
        params: { projectid: this.project.projectid, type: 1 },
      });
    },
    async toWSJJ() {
      let nowdate = await request({
        method: "get",
        url: "xtgl/sysdata",
      });
      if (
        new Date(this.project.projectjkactualendtime).getTime() <=
        new Date(nowdate).getTime() &&
        this.project.projectjkactualendtime != null
      ) {
        this.$router.push({
          name: "biddingView",
          params: { project: this.project, type: 1 },
        });
        return;
      }
      if (+this.project.projectstatus <= 10) {
        this.$message.warning("项目还未发布");
        return;
      }
      if (+this.$store.getters.loginUser.comtype === 3) {
        let res = await request({
          method: "get",
          url: "/xmgl/project/getPsuListByComId",
          params: {
            projectid: this.project.projectid,
            comid: this.$store.getters.loginUser.comid,
            cosid: this.$store.getters.loginUser.cosid,
            offset: 0,
            limit: 1,
          },
        });
        if (+res.list[0].projectbmamt > 0) {
          if (+res.list[0].psubmpaytype === 0) {
            this.$message.warning("还未支付报名费");
            return;
          }
          if (+res.list[0].psubmpayflg !== 1) {
            this.$message.warning("报名费未确认");
            return;
          }
        }
        if (+res.list[0].projectbzjamt > 0) {
          if (+res.list[0].psubzjpaytype === 0) {
            this.$message.warning("还未支付保证金");
            return;
          }
          if (+res.list[0].psubzjpayflg !== 1) {
            this.$message.warning("保证金未确认");
            return;
          }
        }
        let nowdate = await request({
          method: "get",
          url: "xtgl/sysdata",
        });
        if (
          moment(new Date(nowdate).getTime() + 0.5 * 3600 * 1000).isBefore(
            this.project.prsbjbegtime
          )
        ) {
          this.$message.warning("未到竞价开始时间");
          return;
        }
        if (+row.prsflg === 1 || +row.prsflg === 3)
          this.$router.push({
            name: "pbrCenterForm",
            params: {
              projectid: this.project.projectid,
              psuid: this.project.psuid,
              type: 1,
            },
          });

        if (+row.prsflg === 4 || +row.prsflg === 5)
          this.$router.push({
            name: "auctionHall",
            params: {
              projectid: this.project.projectid,
              psuid: this.project.psuid,
              type: 1,
            },
          });
      } else {
        let nowdate = await request({
          method: "get",
          url: "xtgl/sysdata",
        });
        if (
          moment(new Date(nowdate).getTime() + 0.25 * 3600 * 1000).isBefore(
            this.project.prsbjbegtime
          )
        ) {
          this.$message.warning("未到竞价开始时间");
          return;
        }
        this.$router.push({
          name: "pbrCenterForm",
          params: {
            projectid: this.project.projectid,
            psuid: this.project.psuid,
            type: 1,
          },
        });
      }
    },
    async toXMPS() {
      if (this.project.projectstatus <= 10) {
        this.$message.warning("项目未发布");
        return;
      }
      if (this.project.projectjkactualendtime == null) {
        this.$message.warning("报价还未结束");
        return;
      }
      this.$router.push({
        name: "projectReviewGcTab",
        params: { projectid: this.project.projectid },
      });
    },
    async toCGBG() {
      if (this.project.projectstatus <= 10) {
        this.$message.warning("项目未发布");
        return;
      }
      if (this.project.projectjkactualendtime == null) {
        this.$message.warning("报价还未结束");
        return;
      }
      if (this.project.projectstatus < 30) {
        this.$message.warning("还未初审");
        return;
      }
      if (+this.project.projectjjreportflg === 0) {
        this.$message.warning("该项目不需要采购报告");
        return;
      }
      if (+this.project.projectjjbgstatus === 1) {
        this.$router.push({
          name: "projectReportE",
          params: { projectid: this.project.projectid, type: 4 },
        });
      } else if (+this.project.projectjjbgstatus === 2) {
        this.$router.push({
          name: "projectReportW",
          params: { projectid: this.project.projectid, type: 4 },
        });
      } else {
        this.$router.push({
          name: "projectReportW",
          params: { projectid: this.project.projectid, type: 4 },
        });
      }
    },
    async toCJGL() {
      if (this.project.projectstatus <= 10) {
        this.$message.warning("项目未发布");
        return;
      }
      if (this.project.projectjkactualendtime == null) {
        this.$message.warning("报价还未结束");
        return;
      }
      if (this.project.projectstatus < 30) {
        this.$message.warning("项目还未初审");
        return;
      }
      if (this.project.projectstatus < 30) {
        this.$message.warning("项目还未初审");
        return;
      }
      if (
        +this.project.projectjjreportflg === 1 &&
        +this.project.projectjjbgstatus !== 3
      ) {
        this.$message.warning("采购报告还未通过");
        return;
      }
      if (this.project.psubidflgcount > 0) {
        if (+this.project.projectstatus === 40) {
          this.$router.push({
            name: "pbidConfirmForm",
            params: { form: this.project, type: 1 },
          });
        } else {
          this.$router.push({
            name: "pjnoticeIndex",
            params: { projectid: this.project.projectid, type: 1 },
          });
        }
      } else {
        this.$router.push({
          name: "pbidConfirmForm",
          params: { form: this.project, type: 1 },
        });
      }
    },
    //获取协议
    async getPtcInfo(ptcid) {
      let res = await request({
        method: "get",
        url: "/xmgl/ptc/getptcInfo",
        params: { ptcid: ptcid },
      });
      this.ptcInfo = res;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/table.scss";

.view-content {
  width: 611px;
  color: #999999;

  span {
    color: #999999 !important;
  }
}
</style>
